import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getReviewInvoice } from 'modules/_common/api';

export const useQueryReviewInvoice = ({
  invoiceId,
  enabled,
}: {
  invoiceId: string;
  enabled: boolean;
}) => {
  return useQuery(
    [QUERY_KEYS.INVOICES_FISCALIZATION_REVIEW_INVOICE, invoiceId],
    () => getReviewInvoice(invoiceId),
    {
      enabled,
    },
  );
};
